export const mapQueueNameToReadable = (queueName: string): string => {
  const queueNameMap: Record<string, string> = {
    support_email: "the Email support team",
    support_voice: "the Voice support team",
    support_phone_numbers: "the Phone numbers support team",
    support_messaging: "the Messaging support team",
    support_accounts_billing: "the Account administration support team",
  };

  return queueNameMap[queueName] || "an another support team";
};
